<template>
  <nav class="navbar navbar-expand-sm navbar-dark fixed-top" style="background-color: #555">
    <div class="container">
      <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand">
        <i class="fa fa-home"></i>
      </a>
      <!-- <router-link :to="{name: 'home'}" class="navbar-brand"> -->
      <!-- <img src="http://localhost:3000/storage/setdakbr.png" class="my-2" style="height: 50px; margin-right: 30px"> -->
      <!-- <i class="fa fa-home"></i>
            </router-link> -->
      <button
        class="navbar-toggler"
        type="button"
        style="margin-right: 15px"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item dropdown" style="padding-left: 15px; font-size: 16px">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Profil </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <!-- <li>
                            <a :href="$router.resolve({name: 'Profil'}).href" class="nav-link active" aria-current="page">
                                Profil
                            </a>
                            </li> -->
              <li>
                <a :href="$router.resolve({ name: 'Sambutan' }).href" class="nav-link active" aria-current="page"> Sambutan </a>
              </li>
              <li>
                <a :href="$router.resolve({ name: 'Visi dan Misi' }).href" class="nav-link active" aria-current="page"> Visi dan Misi </a>
              </li>
              <li>
                <a :href="$router.resolve({ name: 'Data Pejabat' }).href" class="nav-link active" aria-current="page"> Data Pejabat </a>
              </li>
              <li>
                <a :href="$router.resolve({ name: 'Struktur Organisasi' }).href" class="nav-link active" aria-current="page">Struktur Organisasi </a>
              </li>
            </ul>
          </li>
          <li class="nav-item" style="padding-left: 15px; font-size: 16px">
            <a :href="$router.resolve({ name: 'Berita' }).href" class="nav-link active" aria-current="page">Berita</a>
            <!-- <router-link :to="{name: 'berita'}" class="nav-link active" aria-current="page">Berita</router-link> -->
          </li>
          <li class="nav-item" style="padding-left: 15px; font-size: 16px">
            <router-link :to="{ name: 'Dokumen' }" class="nav-link active" aria-current="page">Dokumen</router-link>
          </li>
          <li class="nav-item dropdown" style="padding-left: 15px; font-size: 16px">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Galeri </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><router-link :to="{ name: 'Album' }" class="nav-link active" aria-current="page">Galeri Foto</router-link></li>
              <li><router-link :to="{ name: 'Video' }" class="nav-link active" aria-current="page">Galeri Video</router-link></li>
            </ul>
          </li>
          <li class="nav-item dropdown" style="padding-left: 15px; font-size: 16px">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Kontak </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><router-link :to="{ name: 'Kontak' }" class="nav-link active" aria-current="page">Kontak Kami</router-link></li>
              <li><router-link :to="{ name: 'WhatsApp' }" class="nav-link active" aria-current="page">Whatsapp</router-link></li>
            </ul>
          </li>
          <!-- <li class="nav-item" style="padding-left: 15px; font-size: 16px;">
                <router-link :to="{name: 'kontak'}" class="nav-link active" aria-current="page">Kontak</router-link>
                </li> -->
          <li class="nav-item dropdown" style="padding-left: 15px; font-size: 16px">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Pengaduan </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <!-- <li>
                        <router-link :to="{name: 'e-office'}" class="nav-link active" aria-current="page">
                            E-Office
                        </router-link>
                    </li> -->
              <li>
                <router-link :to="{ name: 'SiBadra' }" class="nav-link active" aria-current="page"> SiBadra </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'SP4N Lapor' }" class="nav-link active" aria-current="page"> SP4N Lapor </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- <ul class="mt-3 ms-auto" style="padding-left: 1rem !important">
                    <a href="#" onclick="doGTranslate('id|id');return false;" title="Bahasa Indonesia">
                        <img src="/indonesia.png" style="width: 25px;" />
                    </a>
                    <font color="white" class="mx-1"> | </font>
                    <a href="#" onclick="doGTranslate('id|en');return false;" title="English">
                        <img src="/english.png" style="width: 25px;" />
                    </a>
                </ul> -->
        <ul class="mt-3 ms-auto" style="padding-left: 1rem !important">
          <a href="#" @click.prevent="changeLanguage('id|id')" title="Bahasa Indonesia">
            <img src="/indonesia.png" style="width: 25px" />
          </a>
          <font color="white" class="mx-1"> | </font>
          <a href="#" @click.prevent="changeLanguage('id|en')" title="English">
            <img src="/english.png" style="width: 25px" />
          </a>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeadComponent",
  methods: {
    changeLanguage(lang) {
      if (window.doGTranslate) {
        window.doGTranslate(lang);
      } else {
        console.error("doGTranslate function is not defined");
      }
    },
  },
};
</script>
